
interface MapControlTitleProps {
    title: string
}
export const MapControlTitle = ({
    title,
}: MapControlTitleProps) => {

    return (
        <div className="google-map-title">
            <div className="google-map-title-content">
                {title}
            </div>
        </div>
    )
}
